import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MonedoService } from 'src/app/core/services/monedo.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-credit-parameters',
  templateUrl: './credit-parameters.component.html',
  styleUrls: ['./credit-parameters.component.scss']
})
export class CreditParametersComponent implements OnInit {

  creditForm!: FormGroup;

  ownershipOptions = [
    { value: 'Owned', label: 'Owned' },
    { value: 'Rented', label: 'Rented' },
    { value: 'Family', label: 'Family' },
    { value: 'Company Provided', label: 'Company Provided' }
  ];

  occupationOptions = [
    { value: 'salaried', label: 'Salaried' },
    { value: 'self-employed', label: 'Self-Employed' }
  ];

  employmentOptions = [
    { value: 'Salaried', label: 'Salaried' },
    { value: 'Self-Employed', label: 'Self-Employed' }
  ];

  constructor(
    private fb: FormBuilder,
    private monedoService: MonedoService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.creditForm = this.fb.group({
      residenceOwnership: ['', Validators.required],
      occupation: ['', Validators.required],
      employementType: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.creditForm.invalid) {
      this.creditForm.markAllAsTouched();
      return;
    }

    this.spinner.show();
    this.monedoService.SaveCreditParameters(this.creditForm.value).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        console.log('Credit parameters saved', res);
        // User requested redirect to assist-underwrite usually after consent
        this.router.navigateByUrl('/assist-journey/assist-underwrite');
      },
      error: (err: any) => {
        this.spinner.hide();
        console.error('Error saving credit parameters', err);
        // Handle error appropriately, maybe still navigate or show message
        this.router.navigateByUrl('/assist-journey/assist-underwrite');
      }
    });
  }

}
